import { render } from "./Home.vue?vue&type=template&id=89b90f12&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=89b90f12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-89b90f12"

export default script